import { createSlice } from '@reduxjs/toolkit';
import { langMapWithLocale } from 'app/common/js/utils/I18n';

// Initial state for language slice
const initialState = {
  selectedLanguage: localStorage.getItem('language') || (navigator.language && navigator.language.split('-')[0]) || 'en',
};

// Create language slice
const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      let language = action.payload.language;
      language = langMapWithLocale(language);
      state.selectedLanguage = language;
      // Sync with localStorage
      if (action.payload.updateLocalStorage) localStorage.setItem('language', language);
    },
  },
});

// Export actions
export const { setLanguage } = languageSlice.actions;

export const languageReducer = languageSlice;

export default languageSlice.reducer;
